"use client";
import Link from "next/link";
import { ArrowRight, Users, Briefcase } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { careersContact as data } from "@/lib/data/contact";

const accent = "var(--color-crimson)";

export function CareersContact() {
  return (
    <Section id="careers-inquiry" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-crimson)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-10 grid lg:grid-cols-2 gap-5">
          <Reveal delay={100}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                  <Users className="h-4 w-4" style={{ color: accent }} />
                </span>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Open Roles Across Functions</span>
              </div>
              <div className="mt-4 space-y-2">
                {data.roles.map((r, i) => (
                  <div key={i} className="text-sm">
                    <span className="font-semibold" style={{ color: accent }}>{r.area}</span>
                    <span className="text-[rgb(var(--fg-muted))]"> — {r.focus}</span>
                  </div>
                ))}
              </div>
              <div className="mt-6">
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>What We Look For</span>
                <p className="mt-2 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.whatWeLookFor}</p>
              </div>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                  <Briefcase className="h-4 w-4" style={{ color: accent }} />
                </span>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Application Process</span>
              </div>
              <div className="mt-4 space-y-2">
                {data.process.map((p, i) => (
                  <div key={i} className="flex items-baseline gap-2 text-sm text-[rgb(var(--fg-muted))]">
                    <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{p.step}</span>
                    <span>{p.title} {p.body}</span>
                  </div>
                ))}
              </div>
              <div className="mt-6">
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{data.internships.title}</span>
                <p className="mt-2 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.internships.body}</p>
              </div>
            </div>
          </Reveal>
        </div>
        <Reveal delay={400}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
